/**
 * Contracts Domain Constants
 */

// ============================================
// Pagination
// ============================================

export const DEFAULT_PAGE_SIZE = 10
export const MAX_PAGE_SIZE = 1000

// ============================================
// Default Values
// ============================================

export const DEFAULT_CURRENCY = 'SAR'
export const DEFAULT_SALES_ORDER_SORT = {
  sortBy: 'createdAt',
  sortOrder: 'desc',
} as const

export const DEFAULT_PRODUCT_NAME = {
  en: 'Unknown Product',
  ar: 'منتج غير معروف',
} as const

// ============================================
// API Endpoints
// ============================================

export const SALES_ORDER_ENDPOINTS = {
  LIST: '/api/sales-orders',
  DETAIL: (id: string) => `/api/sales-orders/${id}`,
  DOWNLOAD_ORDERS_PDF: (id: string) => `/api/sales-orders/${id}/orders/pdf`,
  CREATE: '/api/sales-orders',
  UPDATE: (id: string) => `/api/sales-orders/${id}`,
  DELETE: (id: string) => `/api/sales-orders/${id}`,
  STATS: '/api/sales-orders/stats',
} as const

// ============================================
// Status Mappings
// ============================================

export const API_STATUS_TO_DOMAIN = {
  draft: 'draft',
  active: 'active',
  completed: 'completed',
  on_hold: 'active',
  canceled: 'canceled',
  failed: 'active',
} as const
